/**
 * Pattern matching valid Font Awesome icon class strings.
 * Allows prefix (fas, far, fal, fab, fad, fak) followed by one or more icon names.
 */
const FA_ICON_PATTERN = /^(fa[srlbdk]?\s+fa-[a-z0-9-]+(\s+fa-[a-z0-9-]+)*)$/;

/**
 * Resolves an icon class string with fallback behavior.
 * Validates against Font Awesome class pattern to prevent className injection.
 * @param {string|null|undefined} icon - CSS class string from API
 * @returns {string} Validated icon class or fallback "fas fa-calendar"
 */
export function resolveIcon(icon) {
  if (typeof icon === "string" && FA_ICON_PATTERN.test(icon.trim())) {
    return icon.trim();
  }
  return "fas fa-calendar";
}
